module.exports = __webpack_public_path__ + "img/MS_WeaponSword009.a32cf9ea.png";